import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import '../../Form.css';
import { getDefaultValues } from 'ra-core';
import { STATUSES_PAYMENT } from '../../../common';
import DateTimeEditor from '../../../components/DateTimeEditor'

let Edit = props => {
  const { handleSubmit, companies } = props;
  return (
    <form className="ScForm" onSubmit={handleSubmit}>
      <div>
        <h2>Редактирование платежа</h2>
        <div>
          <Field
            name="companyId"
            component="select"
          >
            {companies.map(({ id, name }) => <option key={id} value={id}>{name}</option>)}
          </Field>
        </div>
      </div>
      <div className="ScFormRow_50">
        <Field name="time" component={DateTimeEditor} showTime={false}/>
        <div className="ScFormCol_50_right">
          <Field name="status" component="select">
            {STATUSES_PAYMENT.map(({ id, name, color }) => <option key={id} value={id} style={{ color }}>{name}</option>)}
          </Field>
        </div>
      </div>
      <div>
        <label>Сумма</label>
        <Field name="sum" component="input" type="number" placeholder="" />
      </div>
      <div>
        <label>Комментарий</label>
        <Field name="comment" component="input" type="text" placeholder="" />
      </div>
      <div>
        <button type="submit">
            Редактировать платеж
        </button>
      </div>
    </form>
  );
};

Edit = reduxForm({
  form: 'editPayment'
})(Edit);

Edit = connect((state, props) => ({
  initialValues: getDefaultValues(state, props),
  saving: props.saving || state.admin.saving,
}))(Edit);

export default Edit;



// WEBPACK FOOTER //
// ./src/pages/admin/payments/Edit.js